var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoContent(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Flat",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m34 6v3h-30v-3c0-1.1.9-2 2-2h26c1.1 0 2 .9 2 2z",
    fill: "#325068"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m34 9v33c0 1.1-.9 2-2 2h-26c-1.1 0-2-.9-2-2v-33z",
    fill: "#b8c3d5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m28 18.5h-18c-.55 0-1-.45-1-1s.45-1 1-1h18c.55 0 1 .45 1 1s-.45 1-1 1z",
    fill: "#9dabc4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m28 24.5h-18c-.55 0-1-.45-1-1s.45-1 1-1h18c.55 0 1 .45 1 1s-.45 1-1 1z",
    fill: "#9dabc4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m28 30.5h-18c-.55 0-1-.45-1-1s.45-1 1-1h18c.55 0 1 .45 1 1s-.45 1-1 1z",
    fill: "#9dabc4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m28 36.5h-18c-.55 0-1-.45-1-1s.45-1 1-1h18c.55 0 1 .45 1 1s-.45 1-1 1z",
    fill: "#9dabc4"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m60 22v3h-30v-3c0-1.1.9-2 2-2h26c1.1 0 2 .9 2 2z",
    fill: "#325068"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m60 25v33c0 1.1-.9 2-2 2h-26c-1.1 0-2-.9-2-2v-33z",
    fill: "#b8c3d5"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m54 34.5h-18c-.55 0-1-.45-1-1s.45-1 1-1h18c.55 0 1 .45 1 1s-.45 1-1 1z",
    fill: "#9dabc4"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m54 40.5h-18c-.55 0-1-.45-1-1s.45-1 1-1h18c.55 0 1 .45 1 1s-.45 1-1 1z",
    fill: "#9dabc4"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m54 46.5h-18c-.55 0-1-.45-1-1s.45-1 1-1h18c.55 0 1 .45 1 1s-.45 1-1 1z",
    fill: "#9dabc4"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m54 52.5h-18c-.55 0-1-.45-1-1s.45-1 1-1h18c.55 0 1 .45 1 1s-.45 1-1 1z",
    fill: "#9dabc4"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m47 15v3h-30v-3c0-1.1.9-2 2-2h26c1.1 0 2 .9 2 2z",
    fill: "#536882"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m47 18v33c0 1.1-.9 2-2 2h-26c-1.1 0-2-.9-2-2v-33z",
    fill: "#d3dce5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#536882"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m25 32.72c-.26 0-.51-.1-.71-.29-.39-.39-.39-1.02 0-1.41l3.66-3.66c.39-.39 1.02-.39 1.41 0s.39 1.02 0 1.41l-3.66 3.66c-.2.2-.45.29-.71.29z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m28.66 32.72c-.26 0-.51-.1-.71-.29l-3.66-3.66c-.39-.39-.39-1.02 0-1.41s1.02-.39 1.41 0l3.66 3.66c.39.39.39 1.02 0 1.41-.2.2-.45.29-.71.29z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m35.34 32.72c-.26 0-.51-.1-.71-.29-.39-.39-.39-1.02 0-1.41l3.66-3.66c.39-.39 1.02-.39 1.41 0s.39 1.02 0 1.41l-3.66 3.66c-.2.2-.45.29-.71.29z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m39 32.72c-.26 0-.51-.1-.71-.29l-3.66-3.66c-.39-.39-.39-1.02 0-1.41s1.02-.39 1.41 0l3.66 3.66c.39.39.39 1.02 0 1.41-.2.2-.45.29-.71.29z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m38.47 42.53c-.36 0-.7-.19-.88-.53-1.1-2.07-3.24-3.35-5.58-3.35s-4.48 1.28-5.58 3.35c-.26.49-.87.67-1.35.41-.49-.26-.67-.87-.41-1.35 1.45-2.72 4.26-4.41 7.35-4.41s5.9 1.69 7.35 4.41c.26.49.08 1.09-.41 1.35-.15.08-.31.12-.47.12z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoContent);
export default __webpack_public_path__ + "static/media/no-content.0fceef1c6b6a6d283fb12ad8a1698524.svg";
export { ForwardRef as ReactComponent };